import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sapSuccessFactors = defineConnector({
  identifier: "sapSuccessFactors",
  name: "SAP SuccessFactors",
  tagLine: "Human experience management",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.successfactors\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: `${app.config.companyId}\\\\${app.config.hostname}`,
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your SAP SuccessFactors instance and navigate to **Admin Center > Manage OAuth2 Client Applications** to register a new application and obtain your API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "API server hostname",
          required: true,
          placeholder: "apisalesdemo2.successfactors.eu",
          helperText: "Your SAP SuccessFactors API server hostname.",
          target: { kind: "configuration", field: "hostname" },
        },
        {
          kind: "input",
          label: "Company ID",
          required: true,
          placeholder: "Your Company ID",
          target: { kind: "configuration", field: "companyId" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          placeholder: "Your API key",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ hostname }) =>
      `https://${hostname}/odata/v2/User?$top=1&$format=json`,
  },
  publicEnvVars: ({ hostname }) => ({
    SAP_SUCCESS_FACTORS_URL: hostname ? `https://${hostname}` : "",
  }),
});
